import React from "react";

// Tick icon within circle
export const TickIcon = () => {
  return (
    <svg width="56" height="55" viewBox="0 0 56 55" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.85 27.5L23.95 35.45L40.15 19.55M55 27.5C55 42.1354 42.9116 54 28 54C13.0883 54 1 42.1354 1 27.5C1 12.8644 13.0883 1 28 1C42.9116 1 55 12.8644 55 27.5Z"
        stroke="#27DD8B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SimpleTickIcon = ({ color = "white" }) => {
  return (
    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3333 1L3.91667 7.41667L1 4.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
